import { Duration } from 'luxon'

// duration is in ISO format; e.g. "PT1H" for 1 hour or "PT1D" for 1 day
export const getMinOrMaxFromISODuration = (duration: string, minOrMax: 'min' | 'max') => {
    const hours = Duration.fromISO(duration).as('hours')
    return minOrMax === 'min' ? Math.ceil(hours) : Math.floor(hours)
}

export const getIsoDurationInDays = (duration: string): number => {
    if (!duration) return 1
    const days = Duration.fromISO(duration).as('days')
    if (days < 1) {
        return 0
    }
    return Math.floor(days)
}
